import { FormErrors } from 'redux-form';
import isArray from 'lodash/isArray';

/**
 * Error from server
 */
interface Error<T> {
    detail: string;
    title: string;
    violations: ErrorItem<T>[];
}
interface ErrorM<T> {
    detail: string;
    title: string;
    message: string;
    violations: ErrorItem<T>[];
}

interface ErrorItem<T> {
    propertyPath: keyof T;
    message: string;
}

/**
 * Apply common errors to form fields
 */
export function makeFormErrors<T>(errors: Error<T>): FormErrors<T> {
    const result: FormErrors<T> | any = {};

    if (errors.title) {
        result['_error'] = errors.title;
    }
    if (errors.detail) {
        result['_error'] = errors.detail;
    }
    if (isArray(errors.violations)) {
        errors.violations.forEach((error: ErrorItem<T>) => {
            result[error.propertyPath] = error.message;
        });

        // `detail` repeats every violation prefixed with its raw property path
        // ("caseNumberValidityTo: End date is required."). The field itself already shows the
        // message, so the summary keeps the sentences only.
        const messages = errors.violations.map((error: ErrorItem<T>) => error.message).filter(Boolean);
        if (messages.length) {
            result['_error'] = messages.join('\n');
        }
    }

    return result;
}

export function makeFormErrorsWithMessage<T>(errors: ErrorM<T>): FormErrors<T> {
    const result: FormErrors<T> | any = {};

    if (errors.message) {
        result['_error'] = errors.message;
    }
    if (errors.title) {
        result['_error'] = errors.title;
    }
    if (errors.detail) {
        result['_error'] = errors.detail;
    }

    return result;
}
